<script setup>
const globalStore = useGlobalStore();
onMounted(() => {
  globalStore.initMySkills();
});
</script>

<template>
  <div class="theme-light">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <AppFaq />
  </div>
</template>
